<template>
  <Transaction
    v-if="session.loggedIn"
    :menu="menu"
    :session="session"
    :environment="environment"
    :generalExApplicationEx="generalExApplicationEx"
    :applicationName="applicationName"
    :flaps="flaps"
    :inputData="inputData"
    :method="method"
    :closeSubmit="closeSubmit"
    :inputBreadCrumbs="inputBreadCrumbs"
    :embedded="embedded"
    :customLanguage="customLanguage"
    :sourceActionType="sourceActionType"
    :sourceAction="sourceAction"
    :external="external"
    :custom="custom"
    @exit-transaction="exitTransaction"
    @exit-all-transaction="exitAllTransaction"
    @select-flap="selectFlap"
    @update-notification="updateNotification"
    @switch-language="switchLanguage"
    @close-parent-flap="closeParentFlap"
    @close-parent-all-flap="closeParentAllFlap"
    @user-interaction="userInteraction"
    @close-dialog="closeDialog"
    @transaction-process="transactionProcess"
    ref="transactionRef"
  />
</template>

<script>
import Transaction from "./Transaction";
export default {
  name: "Flap",
  data() {
    return {
      transactionEx: {},

      transactionName: "",
      transactionLoaded: false,
      flaps: {},

      dynamicMenu: {},

      actionType: null,
    };
  },
  props: [
    "menu",
    "session",
    "environment",
    "simpleHeader",
    "showSuccess",
    "showError",
    "inputData",
    "generalExApplicationEx",
    "applicationName",
    "outputType",
    "method",
    "closeSubmit",
    "actionCalling",
    "inputBreadCrumbs",
    "embedded",
    "customLanguage",
    "sourceActionType",
    "sourceAction",
    "external",
    "custom",
  ],
  components: {
    Transaction,
  },
  methods: {
    callFlap(getMenu, getActionType) {
      this.transactionName = getMenu.transactionName;
      this.actionType = getActionType;
      this.showInitialFlap(getMenu, 0);
    },

    cleanData() {
      this.transactionEx = {};
      this.transactionName = "";
      this.transactionLoaded = false;
      this.flaps = {};
      this.$refs.transactionRef.cleanData();
    },

    parseFlaps(getSelected) {
      const items = this.transactionEx.flaps;
      this.flaps = {
        count: 0,
        selected: getSelected,
        items: items ? items : [],
      };
      this.flaps.count = items ? items.length : 0;
    },

    parseTransaction(getSelected) {
      if (this.transactionLoaded) {
        if (this.transactionEx.transaction.type == "flap") {
          this.parseFlaps(getSelected);
          this.dynamicMenu = this.menu;
          this.dynamicMenu.transactionName =
            this.flaps.items[this.flaps.selected].targetName;
          this.$refs.transactionRef.callTransaction(
            this.dynamicMenu,
            this.actionType
          );
        } else {
          this.dynamicMenu = this.menu;
          this.$refs.transactionRef.callTransaction(
            this.dynamicMenu,
            this.actionType
          );
        }
      }
    },

    bringFlapData(getTransactionName, getSelected) {
      if (getTransactionName != null) {
        this.cleanData();
        if (this.notBlank(getTransactionName)) {
          this.transactionName = getTransactionName;
          this.transactionLoaded = false;
          this.apiGetFlaps({ path: { transactionName: this.transactionName } })
            .then((transactionRes) => {
              if (this.getTranApiSuccess(transactionRes.data)) {
                this.transactionEx = transactionRes.data;
                this.transactionLoaded = true;
                this.parseTransaction(getSelected);
              } else {
                this.updateNotification({
                  custom: "error",
                  content: this.getTranApiMessages(transactionRes.data, true),
                });
              }
            })
            .catch((transactionErr) => {
              this.updateNotification({
                custom: "error",
                content: transactionErr,
              });
            });
        }
      }
    },

    showInitialFlap(getMenu, getSelected) {
      this.bringFlapData(getMenu.transactionName, getSelected);
    },

    selectFlap(getSelected) {
      if (getSelected != this.flaps.selected) {
        this.bringFlapData(this.transactionName, getSelected);
      }
    },

    exitTransaction(data) {
      this.$emit("exit-flap", data);
    },

    exitAllTransaction(data) {
      this.$emit("exit-all-flap", data);
    },

    updateNotification(data) {
      this.$emit("update-notification", data);
    },

    switchLanguage() {
      this.$emit("switch-language");
    },

    initCloseFlap(data, embed) {
      this.$refs.transactionRef.initCloseTransaction(data, embed);
    },

    initCloseAllFlap(data, embed) {
      this.$refs.transactionRef.initCloseAllTransaction(data, embed);
    },

    closeParentFlap(data, embed) {
      this.$emit("close-parent-embed", data, embed);
    },
    closeParentAllFlap(data, embed) {
      this.$emit("close-parent-all-embed", data, embed);
    },
    userInteraction(args) {
      this.$emit("user-interaction", args);
    },
    closeDialog(data) {
      this.$emit("close-dialog", data);
    },
    transactionProcess(getSuccess, getData, getResponse) {
      this.$emit("transaction-process", getSuccess, getData, getResponse);
    },
  },
};
</script>

<style scoped>
</style>